  <template>
    <!--  -->
  <div class="modal fade" id="UploadItemModal" tabindex="-1" aria-labelledby="UploadItemModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="UploadItemModalLabel">Upload Items</h5>
          <button type="button" class="close_modal_bt" data-bs-dismiss="modal" aria-label="Close">X</button>
        </div>
        <div class="modal-body">
          <form>
           
            <div class="mb-3">
              <label for="formFile" class="form-label">Choose an Excel (.xlsx) or ODS file:</label>
              <input class="form-control" type="file" id="formFile" ref="fileInput" accept=".xlsx,.ods"  @change="handleFileChange">
              <div v-if="validationMessage" class="text-danger mt-2">{{ validationMessage }}</div>
            </div>
            <!-- <button  class="btn btn-primary" @click="submitFile" :disabled="!isValidFile || isLoading">Upload</button> -->
             <!-- download_template -->
             <button type="button" class="mycustom-success-button neutral" @click="download_template">
                        <i class="bi bi-plus-square-dotted"></i> <i class="bi bi-plus-circle-dotted"></i> Download Items Template
             </button>
            <button @click="submitFile" class="btn btn-primary righter">Submit</button>

          </form>
        </div>
       
      </div>
    </div>
  </div>
     <!--  -->
  </template>
<script>
import { generalApiUploadRequest, generalApiDownloadRequest } from "../../../api/apiIndex";
export default {
  data() {
    return {
      validationMessage: '',
      selectedFile: null,
      isLoading: false, // Flag for upload in progress
    };
  },
  computed: {
    isValidFile() {
      return this.validationMessage === '' && this.selectedFile !== null;
    }
  },
  methods: {
    handleFileChange(event) {
      const file = event.target.files[0];

      if (!file) {
        this.validationMessage = '';
        this.selectedFile = null;
        return;
      }

      const allowedExtensions = ['.xlsx', '.ods'];
      const extension = file.name.slice(-4).toLowerCase();

      if (!allowedExtensions.includes(extension)) {
        this.validationMessage = 'Please select an Excel (.xlsx) or ODS file.';
        this.selectedFile = null;
      } else {
        this.validationMessage = '';
        this.selectedFile = file;
       // console.log(this.selectedFile);
      }
    },
    async submitFile() {
      if (!this.isValidFile) {
        return;
      }

      this.isLoading = true; // Set loading flag

      // Prepare data for upload (replace with your logic)
      const formData = new FormData();
      formData.append('file', this.selectedFile);

      try {
        const response = generalApiUploadRequest('inventory/upload_items', formData, 1);
        console.log(response);
        // Handle successful upload (e.g., clear form, show success message)
      } catch (error) {
        console.error('Error uploading file:', error);
        // Handle upload error (e.g., show error message)
      } finally {
        this.isLoading = false; // Clear loading flag after upload attempt
        this.selectedFile = null; // Clear file selection
      }
    },
    async download_template(){
      const da_data = {};
      await generalApiDownloadRequest('inventory/download_items_template', 'GET', da_data, 'items_tepmplate.ods', 1);
   
    },
  },
};
</script>

